<template>
  <div class="list">
    <div class="header">
      <div class="l">
        <div class="label">
          支付状态
        </div>
        <el-select
          v-model="searchForm.valid"
          placeholder="请选择支付状态"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in evaluationList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div class="r">
        <el-input
          v-model="searchForm.evaluationName"
          placeholder="请输入行业名称"
          @keyup.enter.native="getList()"
        >
          <el-button
            slot="append"
            type="primary"
            @click="getList()"
          >
            搜索
          </el-button>
        </el-input>
        <el-button
          type="primary"
          @click="create"
        >
          新建行业
        </el-button>
      </div>
    </div>
    <data-table
      :data="tabelData"
      :table-column="tableColumn"
      :pagination="true"
      @changeBypagination="tableHandle"
      @buttonClick="buttonClick"
    />
  </div>
</template>

<script>
import axClient from '@/services';
import dataTable from '@/components/common/dataTable.vue';
import types, { evaluationList } from '@/config';

export default {
  name: 'Order',
  components: {
    dataTable,
  },
  data() {
    return {
      evaluationList,
      refundVisible: false,
      orderAgencyVisible: false,
      searchForm: {
        evaluationName: '',
        valid: null,
        pageNum: 1,
        pageSize: 10,
      },
      tabelData: {},
      tableColumn: [
        {
          key: 'evaluationName',
          label: '行业名称',
          dataType: 'text',
        },
        {
          key: 'price',
          label: '价格',
          width: '80px',
          dataType: 'money',
        },
        {
          key: 'virtualBuyCount',
          label: '虚拟购买数量',
          width: '100px',
          dataType: 'text',
        },
        {
          key: 'actualBuyCount',
          label: '实际购买数量',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'valid',
          label: '状态',
          width: '100px',
          dataType: 'function',
          render: (key) => evaluationList.filter((item) => item.value === key),
        },
        {
          key: 'rank',
          label: '排序值',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'control',
          label: '操作',
          width: '240px',
          dataType: 'component',
          renderProps: [
            {
              text: '下架', renderKey: types.EVALUATION_ENABLE, renderProp: 'valid', type: 'success', eventIndex: 0, disableKey: null,
            },
            {
              text: '上架', renderKey: types.EVALUATION_DISABLE, renderProp: 'valid', eventIndex: 0, disableKey: null,
            },
            {
              text: '编辑', renderKey: null, type: 'primary', eventIndex: 1, disableKey: null,
            },
            {
              text: '详情', renderKey: null, type: 'info', eventIndex: 2, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 获取列表
    async getList(num = 1) {
      this.searchForm.pageNum = num;
      const result = await axClient.evaluation.evaluationPage(this.searchForm);
      const { pageNum, pageSize, total } = result;
      this.tabelData = {
        pageNum,
        pageSize,
        total,
        list: result.list,
      };
    },
    // 跳转到详情
    goDetails(item) {
      this.$router.push({ name: 'EvaluationDetails', params: { id: item.id } });
    },
    // table 传递过来的按钮点击
    buttonClick(type, item) {
      switch (type) {
        case 0:
          this.confirmDialog(item);
          break;
        case 1:
          this.create(item);
          break;
        case 2:
          this.goDetails(item);
          break;
        default:
          break;
      }
    },
    // 新增行业
    create(item) {
      this.$router.push({ name: 'EvaluationCreate', params: { id: item.id } });
    },
    // 下架/上架 行业
    confirmDialog(item) {
      this.$confirm('确定下架/上架该行业？', '下架/上架行业', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async() => {
        const { id, valid } = item;
        const data = await axClient.evaluation.evaluationUpdateValid(
          {
            id,
            valid: valid === types.EVALUATION_ENABLE
              ? types.EVALUATION_DISABLE : types.EVALUATION_ENABLE,
          },
        );
        if (data) {
          this.$message.success('上架/下架成功');
          this.getList();
        }
      });
    },
    // table 改变 pagination 时间
    tableHandle(pageNum, pageSize) {
      this.searchForm.pageNum = pageNum;
      this.searchForm.pageSize = pageSize;
      this.getList(pageNum);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
